<template>
<OIconInner :iconString :size :height :display :title :ariaHidden />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { getIcon } from './configs/iconConfig';
import OIconInner, { type OIconInnerProps } from './OIconInner.vue';

export interface OIconProps extends Omit<OIconInnerProps, 'iconString'> {
	// Nazwa ikony (zazwyczaj nazwa plku .svg)
	name?: string;
	// Nazwa zestawu ikon (zazwyczaj nazwa folderu)
	set?: string;
}

const props = withDefaults(defineProps<OIconProps>(), {
	name: 'placeholder',
	set: 'base',
	display: 'inline-block',
});

const iconString = ref('');

watch(
	() => props.name,
	async (val) => {
		iconString.value = await getIcon(props.set, val);
	},
	{ immediate: true }
);
</script>
